import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './FilterTabs.module.scss';
import { ReactComponent as Green } from '../../../assets/icons/u_check-circle.svg';
import { ReactComponent as Yellow } from '../../../assets/icons/u_exclamation-circle.svg';
import { ReactComponent as Red } from '../../../assets/icons/u_multiply-circle.svg';
import { ReactComponent as IconFilter } from '../../../assets/icons/u_filters-v.svg';
import { IconCode } from '../../../models/EarlyWarnings';
import NumberFormat from 'react-number-format';
import { formatMillionNumber } from '../../../services/numberUtil';

const FilterButton = ({ filterObject, handleFilter }) => {
  const { t } = useTranslation();
  const {
    projectQuantityText,
    projectLabelText,
    buttonContainer,
    buttonContainerDisableClick,
    filterLabelText,
    buttonContainerSelectedRed,
    buttonContainerSelectedGreen,
    buttonContainerSelectedYellow,
    filterLabelTextSelected,
    projectQuantityTextSelected,
    projectLabelTextSelected,
    iconContainer,
    topContainer,
    iconFilter,

    containerFilterButton,
  } = styles;

  const {
    projectQuantity,
    projectLabel,
    filterIcon,
    filterLabelRight,
    selected,
    id,
    filterLabelLeft,
    projectAmount,
    projectAmountLabel,
  } = filterObject;

  const projectLabelToRender = projectQuantity > 1 ? projectLabel.plural : projectLabel.singular;

  const handleEnableStyle = (disable, enableStyle) => {
    return projectQuantity === 0 ? disable : enableStyle;
  };

  const handleSelectedStyle = (
    selected,
    id = 0,
    buttonContainerSelectedRed,
    buttonContainerSelectedGreen,
    buttonContainerSelectedYellow,
    noSelectedStyle,
  ) => {
    if (selected && id === 0) {
      return buttonContainerSelectedGreen;
    } else if (selected && id === 1) {
      return buttonContainerSelectedYellow;
    } else if (selected && id === 2) {
      return buttonContainerSelectedRed;
    } else {
      return noSelectedStyle;
    }
  };

  const handleIcon = filterIcon => {
    const iconsComponent = {
      GREEN: <Green className="green-icon" />,
      YELLOW: <Yellow className="yellow-icon" />,
      RED: <Red className="red-icon" />,
    };
    return iconsComponent[IconCode[filterIcon]];
  };

  return (
    <div
      className={`${handleEnableStyle(
        buttonContainerDisableClick,
        handleSelectedStyle(
          selected,
          id,
          buttonContainerSelectedRed,
          buttonContainerSelectedGreen,
          buttonContainerSelectedYellow,
          buttonContainer,
        ),
      )}`}
      onClick={() => projectQuantity > 0 && handleFilter(filterObject)}
    >
      <div className={iconContainer}>
        <p> {handleIcon(filterIcon)}</p>
      </div>
      <div className={containerFilterButton}>
        <div>
          <div className={topContainer}>
            <p className={selected ? projectQuantityTextSelected : projectQuantityText}>{projectQuantity}</p>
            <p className={selected ? projectLabelTextSelected : projectLabelText}>{t(projectLabelToRender.trim())}</p>
          </div>
          <p className={selected ? filterLabelTextSelected : filterLabelText}>{t(filterLabelRight)}</p>
        </div>
        <div>
          <div className={topContainer}>
            <p className={selected ? projectQuantityTextSelected : projectQuantityText}>
              <NumberFormat
                value={formatMillionNumber(projectAmount)}
                displayType={'text'}
                thousandSeparator={'.'}
                decimalSeparator={','}
                decimalScale={1}
              />
            </p>
            <p className={selected ? projectLabelTextSelected : projectLabelText}>{t(projectAmountLabel.singular)}</p>
          </div>
          <p className={selected ? filterLabelTextSelected : filterLabelText}>{t(filterLabelLeft)}</p>
        </div>
      </div>
      <div className={iconFilter}>
        <IconFilter />
      </div>
    </div>
  );
};

export const FilterTabs = ({ dataTabs, fnDataFilter, dataFilter, fnDataButtonsFilter, fnSelectLabel }) => {
  const { container, buttonsContainer, igrMessage } = styles;

  const filterDataTabs = data => {
    if (data.id === 2 && !data.selected) {
      fnDataFilter(dataFilter.filter(item => item.field7 === 'RED'));
      fnSelectLabel('2');
    } else if (data.id === 1 && !data.selected) {
      fnDataFilter(dataFilter.filter(item => item.field7 === 'YELLOW'));
      fnSelectLabel('1');
    } else if (data.id === 0 && !data.selected) {
      fnDataFilter(dataFilter.filter(item => item.field7 === 'GREEN'));
      fnSelectLabel('0');
    } else {
      fnDataFilter(dataFilter);
      fnSelectLabel('3');
    }

    if (dataTabs.find(item => item.id === data.id).selected) {
      const filterConfigComponentToUpdate = dataTabs.map(obj => {
        return { ...obj, selected: false };
      });
      fnDataButtonsFilter(filterConfigComponentToUpdate);
    } else {
      const filterConfigComponentToUpdate = dataTabs.map(obj => {
        if (obj.id === data.id) {
          return { ...obj, selected: true };
        }
        return { ...obj, selected: false };
      });
      fnDataButtonsFilter(filterConfigComponentToUpdate);
    }
  };

  return (
    <div className={container}>
      <div className={buttonsContainer}>
        {dataTabs.map(f => {
          return <FilterButton filterObject={f} handleFilter={filterDataTabs} key={f.id} />;
        })}
      </div>
    </div>
  );
};
